import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('ZoomIn', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
    fillOpacity: "0.01",
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "48",
    height: "48",
    strokeWidth: "4",
    stroke: "none",
    fillRule: "evenodd"
  }), React.createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: "4",
    fill: "none",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: "21",
    cy: "21",
    r: "17"
  }), React.createElement("path", {
    d: "M16.7573593,16.7573593 L25.2426407,25.2426407",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(21.000000, 21.000000) rotate(45.000000) translate(-21.000000, -21.000000) ",
    fill: "none",
    fillRule: "evenodd"
  }), React.createElement("path", {
    d: "M25.2426407,16.7573593 L16.7573593,25.2426407",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(21.000000, 21.000000) rotate(-135.000000) translate(-21.000000, -21.000000) ",
    fill: "none",
    fillRule: "evenodd"
  }), React.createElement("path", {
    d: "M31.4644661,37.4644661 L43.4644661,37.4644661",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(37.464466, 37.464466) rotate(45.000000) translate(-37.464466, -37.464466) ",
    fill: "none",
    fillRule: "evenodd"
  }))));
});